// @flow

export const LOAD_ZONES: 'ZONES.LOAD_ZONES' = 'ZONES.LOAD_ZONES';
export const SET_ZONE: 'ZONES.SET_ZONE' = 'ZONES.SET_ZONE';
export const UNSET_ZONE: 'ZONES.UNSET_ZONE' = 'ZONES.UNSET_ZONE';

export const CREATE_ZONE: 'ZONES.CREATE_ZONE' = 'ZONES.CREATE_ZONE';
export const UPDATE_ZONE: 'ZONES.UPDATE_ZONE' = 'ZONES.UPDATE_ZONE';
export const DELETE_ZONE: 'ZONES.DELETE_ZONE' = 'ZONES.DELETE_ZONE';
export const ACTIVATE: 'ZONES.ACTIVATE' = 'ZONES.ACTIVATE';
export const DEACTIVATE: 'ZONES.DEACTIVATE' = 'ZONES.DEACTIVATE';

export const SET_DRAWING_SHAPE_TYPE: 'ZONES.SET_DRAWING_SHAPE_TYPE' = 'ZONES.SET_DRAWING_SHAPE_TYPE';
export const SET_DRAWING_SHAPE: 'ZONES.SET_DRAWING_SHAPE' = 'ZONES.SET_DRAWING_SHAPE';
export const SET_DRAWING_ZONE: 'ZONES.SET_DRAWING_ZONE' = 'ZONES.SET_DRAWING_ZONE';